import { Component, Input, OnInit } from '@angular/core';
import { LenderService } from '@shared/service/lender/lender.service';

@Component({
  selector: 'dx-check-app-animation',
  templateUrl: './check-app-animation.component.html',
  styleUrl: './check-app-animation.component.scss'
})
export class CheckAppAnimationComponent implements OnInit {
  @Input() color: string;
  // Default size is 300
  @Input() size = '300';
  // Aligns animation to the center of the parent; default is true
  @Input() alignCenter = true;
  // TBD: add type to change the top card to a variation i.e. address, employment, etc
  @Input() type = 'check';

  constructor(private readonly lenderService: LenderService) {}

  public ngOnInit(): void {
    // Get color from lender data or default to baseline blue
    const defaultColor = '#2FA4E7';
    this.color = this.lenderService.lenderDataInfo?.mainColor || defaultColor;

    // Create CSS variable for the primary animation color in RGB (for opacity)
    const rgb = this.hexToRgb(this.color);
    document.documentElement.style.setProperty('--animation-primary-color', rgb);
  }

  /**
   * Converts a color string (hex or comma-separated) to a comma-separated RGB string.
   * - If the input starts with '#' (e.g. "#FF69B4" or "#F69"), it expands it to a 6-digit hex
   *   and converts each two-digit pair to decimal R, G, B.
   * - If the input contains commas or doesn't start with '#', it's assumed to be an existing "R, G, B" format
   *   and returned unchanged.
   *
   * @param hex The input color, either "#RRGGBB", "#RGB", or "R, G, B".
   * @returns Returns a string in "R, G, B" format.
   */
  private hexToRgb(hex: string): string {
    const color = hex.trim();
    const isHex = color.startsWith('#') && !color.includes(',');

    if (isHex) {
      const cleanHex = color.replace('#', '');
      const expandedHex =
        cleanHex.length === 3
          ? cleanHex
              .split('')
              .map((c) => c + c)
              .join('')
          : cleanHex;
      // Extract R, G, B with substring
      const r = parseInt(expandedHex.substring(0, 2), 16);
      const g = parseInt(expandedHex.substring(2, 4), 16);
      const b = parseInt(expandedHex.substring(4, 6), 16);

      return `${r}, ${g}, ${b}`;
    }

    return color;
  }
}
